import React from 'react';
import { Redirect } from 'react-router-dom';

import { settingsPortalPantryPath } from '../../../Paths';

export default () => <Redirect to={settingsPortalPantryPath} />;
